import { render, staticRenderFns } from "./BubbleText.vue?vue&type=template&id=1ad0bdd3&scoped=true&"
import script from "./BubbleText.vue?vue&type=script&lang=js&"
export * from "./BubbleText.vue?vue&type=script&lang=js&"
import style0 from "./BubbleText.vue?vue&type=style&index=0&id=1ad0bdd3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1ad0bdd3",
  null
  
)

export default component.exports